
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5dFS9", function(module, exports) {
/**
 * Note all events fired include the searchSessionId, experiment-id, queryHash, queryVersion, wordCount, resultCount where applicable
 */ const $a652ba3ef37d13f7$export$ed78826c06dd24e3 = 'fabric-elements';
var $a652ba3ef37d13f7$export$41fb9f06171c75f4 = /*#__PURE__*/ function(Trigger) {
    Trigger["SHORTCUT"] = "shortcut";
    Trigger["SHORTCUT_MODIFIED"] = "shortcutModified";
    Trigger["RETURN"] = "return";
    Trigger["CLICK"] = "click";
    Trigger["TEXT_ENTERED"] = "textEntered";
    return Trigger;
}({});
var $a652ba3ef37d13f7$export$f7a2a633defbe589 = /*#__PURE__*/ function(AdvancedSearchLinkSubjectId) {
    AdvancedSearchLinkSubjectId["CONFLUENCE"] = "confluenceAdvancedSearchLink";
    AdvancedSearchLinkSubjectId["CONFLUENCE_PEOPLE"] = "confluencePeopleSearchLink";
    AdvancedSearchLinkSubjectId["JIRA_ISSUES"] = "jiraIssuesSearchLink";
    AdvancedSearchLinkSubjectId["JIRA_BOARDS"] = "jiraBoardsSearchLink";
    AdvancedSearchLinkSubjectId["JIRA_FILTERS"] = "jiraFiltersSearchLink";
    AdvancedSearchLinkSubjectId["JIRA_PROJECTS"] = "jiraProjectsSearchLink";
    AdvancedSearchLinkSubjectId["JIRA_PLANS"] = "jiraPlansSearchLink";
    AdvancedSearchLinkSubjectId["JIRA_PEOPLE"] = "jiraPeopleSearchLink";
    AdvancedSearchLinkSubjectId["NO_RESULTS"] = "noResultsAdvancedSearchLink";
    return AdvancedSearchLinkSubjectId;
}({});
const $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE = 'searchDialog';
const $a652ba3ef37d13f7$export$b544183e0becb531 = ({ trigger: trigger, actionSubjectId: actionSubjectId, isLoading: isLoading, newTab: newTab, isRovoCrossProductSearchLink: isRovoCrossProductSearchLink = false })=>{
    return {
        action: 'selected',
        actionSubject: 'advancedSearchLink',
        actionSubjectId: actionSubjectId,
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'track',
        attributes: {
            trigger: trigger,
            isLoading: isLoading,
            newTab: newTab,
            isRovoCrossProductSearchLink: isRovoCrossProductSearchLink
        }
    };
};
const $a652ba3ef37d13f7$export$7d52695c66ad1422 = ({ trigger: trigger, actionSubjectId: actionSubjectId, isLoading: isLoading, newTab: newTab })=>{
    return {
        action: 'selected',
        actionSubject: 'askAtlassianIntelligenceLink',
        actionSubjectId: actionSubjectId,
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'track',
        attributes: {
            trigger: trigger,
            isLoading: isLoading,
            newTab: newTab
        }
    };
};
const $a652ba3ef37d13f7$export$19360e9b825e4dfb = ({ actionSubjectId: actionSubjectId, searchSessionId: searchSessionId })=>{
    return {
        action: 'dismissed',
        actionSubject: 'stickySearch',
        actionSubjectId: actionSubjectId,
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {
            searchSessionId: searchSessionId
        }
    };
};
const $a652ba3ef37d13f7$export$72e9f7dfc882e584 = ()=>{
    return {
        action: 'triggered',
        actionSubject: 'nonDebouncedSearch',
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui'
    };
};
const $a652ba3ef37d13f7$export$9cb41cdfd7c5452f = ({ timeout: timeout })=>{
    return {
        eventType: 'track',
        action: 'cleared',
        actionSubject: 'stickySearch',
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        attributes: {
            timeout: timeout
        }
    };
};
const $a652ba3ef37d13f7$export$b4f9d93cc4bd7b82 = ({ source: source, attributes: attributes })=>{
    return {
        eventType: 'ui',
        action: 'shown',
        actionSubject: 'link',
        actionSubjectId: 'autocorrect',
        source: source,
        attributes: attributes
    };
};
const $a652ba3ef37d13f7$export$33cdbdfa7f154d6c = ({ source: source, attributes: attributes })=>{
    return {
        eventType: 'ui',
        action: 'clicked',
        actionSubject: 'link',
        actionSubjectId: 'autocorrect',
        source: source,
        attributes: attributes
    };
};
const $a652ba3ef37d13f7$export$82cfcc46988a9165 = ({ actionSubjectId: actionSubjectId })=>({
        eventType: 'ui',
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        action: 'show',
        actionSubject: 'hoverPreview',
        actionSubjectId: actionSubjectId
    });
const $a652ba3ef37d13f7$export$c666b7de327a3cc2 = ({ actionSubjectId: actionSubjectId })=>({
        eventType: 'ui',
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        action: 'shown',
        actionSubject: 'hoverPreview',
        actionSubjectId: actionSubjectId
    });
const $a652ba3ef37d13f7$export$dfba1b0d5d9e4887 = ({ actionSubjectId: actionSubjectId })=>({
        eventType: 'ui',
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        action: 'clicked',
        actionSubject: 'hoverPreview',
        actionSubjectId: actionSubjectId
    });
const $a652ba3ef37d13f7$export$4b429c3d1a2c2d67 = ({ attributes: attributes })=>({
        eventType: 'operational',
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        action: 'failed',
        actionSubject: 'trelloCardRequest',
        attributes: {
            ...attributes
        }
    });
const $a652ba3ef37d13f7$export$b87f0592bfac0edc = (sectionId)=>({
        eventType: 'ui',
        action: 'clicked',
        actionSubject: 'link',
        actionSubjectId: 'searchResultViewAllLink',
        attributes: {
            sectionId: sectionId
        }
    });
const $a652ba3ef37d13f7$export$62946e9fdc11ae8d = ({ trigger: trigger, actionSubjectId: actionSubjectId, isLoading: isLoading, newTab: newTab, destinationId: destinationId, index: index })=>{
    return {
        action: 'selected',
        actionSubject: 'advancedSearchLink',
        actionSubjectId: actionSubjectId,
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {
            trigger: trigger,
            isLoading: isLoading,
            newTab: newTab,
            destinationId: destinationId,
            index: index
        }
    };
};
const $a652ba3ef37d13f7$export$6c5bd82ba411ffb0 = ({ trigger: trigger, selectedFiltersCount: selectedFiltersCount })=>{
    return {
        action: 'selected',
        actionSubject: 'moreFilterLink',
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {
            trigger: trigger,
            selectedFiltersCount: selectedFiltersCount
        }
    };
};
const $a652ba3ef37d13f7$export$7816fccc5a0a2fed = ({ screen: screen, actionSubject: actionSubject })=>{
    return {
        action: 'selected',
        actionSubject: actionSubject,
        actionSubjectId: screen,
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'track',
        attributes: {}
    };
};
const $a652ba3ef37d13f7$export$95ef6569b5b2de4a = ({ screen: screen, actionSubject: actionSubject })=>{
    return {
        action: 'highlighted',
        actionSubject: actionSubject,
        actionSubjectId: screen,
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {}
    };
};
const $a652ba3ef37d13f7$export$656ab76fbb25e04 = ({ screen: screen, actionSubject: actionSubject })=>{
    return {
        action: 'contextMenu opened',
        actionSubject: actionSubject,
        actionSubjectId: screen,
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {}
    };
};
var $a652ba3ef37d13f7$export$676101ab18001bd5 = /*#__PURE__*/ function(ResultsShownActionSubjectId) {
    ResultsShownActionSubjectId["PREQUERY"] = "preQuerySearchResults";
    ResultsShownActionSubjectId["POSTQUERY"] = "postQuerySearchResults";
    ResultsShownActionSubjectId["CACHED"] = "cachedResults";
    ResultsShownActionSubjectId["PREQUERY_ERROR"] = "preQueryError";
    ResultsShownActionSubjectId["POSTQUERY_ERROR"] = "postQueryError";
    return ResultsShownActionSubjectId;
}({});
const $a652ba3ef37d13f7$export$2d1da932f40a427e = ({ actionSubjectId: actionSubjectId, resultCount: resultCount, sectionCount: sectionCount, results: results, timeToQueryMs: timeToQueryMs, activeProduct: activeProduct, isMultiProduct: isMultiProduct, filters: filters, experimentLayers: experimentLayers, bitbucketWorkspacesCount: bitbucketWorkspacesCount, selectedBitbucketWorkspace: selectedBitbucketWorkspace })=>{
    return {
        action: 'shown',
        actionSubject: 'searchResults',
        actionSubjectId: actionSubjectId,
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {
            resultCount: resultCount,
            sectionCount: sectionCount,
            timeToQueryMs: timeToQueryMs,
            results: results,
            noResultsFetched: !resultCount,
            activeProduct: activeProduct,
            isMultiProduct: isMultiProduct,
            filters: filters,
            backendExperiments: {
                experimentLayers: experimentLayers
            },
            bitbucketWorkspacesCount: bitbucketWorkspacesCount,
            selectedBitbucketWorkspace: selectedBitbucketWorkspace
        }
    };
};
const $a652ba3ef37d13f7$export$db28d8e16fb16e80 = (activeProduct)=>{
    return {
        action: 'entered',
        actionSubject: 'text',
        actionSubjectId: 'searchDialogTextField',
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'track',
        attributes: {
            activeProduct: activeProduct
        }
    };
};
const $a652ba3ef37d13f7$export$3484ea513055aa12 = ({ total: total, currentSize: currentSize, pageSize: pageSize })=>{
    return {
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'showMoreButton',
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {
            total: total,
            currentSize: currentSize,
            pageSize: pageSize
        }
    };
};
const $a652ba3ef37d13f7$export$3fb15ebf22b4884e = ({ total: total, currentSize: currentSize, pageSize: pageSize })=>{
    return {
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'showAllLink',
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {
            total: total,
            currentSize: currentSize,
            pageSize: pageSize
        }
    };
};
const $a652ba3ef37d13f7$export$145f05df248491e5 = ({ searchSessionId: searchSessionId, trigger: trigger })=>{
    return {
        name: 'searchDialogPreQueryScreen',
        eventType: 'screen',
        attributes: {
            searchSessionId: searchSessionId,
            trigger: trigger
        }
    };
};
const $a652ba3ef37d13f7$export$93a340bed59d6525 = ({ actionSubjectId: actionSubjectId, timings: timings, activeProduct: activeProduct, isExpanded: isExpanded, isMultiProduct: isMultiProduct, filters: filters, experimentLayers: experimentLayers }, additionalContext = {}, nonPrivacySafeAttributes = {
    query: ''
})=>{
    return {
        action: 'completed',
        actionSubject: 'searchRequest',
        actionSubjectId: actionSubjectId,
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'track',
        attributes: {
            activeProduct: activeProduct,
            isExpanded: isExpanded,
            isMultiProduct: isMultiProduct,
            filters: filters,
            experimentLayers: experimentLayers,
            ...timings,
            ...additionalContext
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    };
};
const $a652ba3ef37d13f7$export$a8d299e4bdceb0be = ()=>({
        action: 'shown',
        eventType: 'ui',
        actionSubject: 'searchResults',
        actionSubjectId: 'preQuerySearchResults',
        attributes: {
            resultCount: 0,
            results: []
        },
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE
    });
const $a652ba3ef37d13f7$export$97e12e4b0f216b1d = (activeProduct)=>{
    return {
        action: 'dismissed',
        actionSubject: 'searchDialog',
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {
            activeProduct: activeProduct
        }
    };
};
const $a652ba3ef37d13f7$export$e79368bde551c62e = ({ visibleProducts: visibleProducts, visibleTabsCount: visibleTabsCount, isRovoCrossProductSearchLinkShown: isRovoCrossProductSearchLinkShown, activeProduct: activeProduct, bitbucketWorkspacesCount: bitbucketWorkspacesCount, selectedBitbucketWorkspace: selectedBitbucketWorkspace })=>{
    return {
        action: 'shown',
        actionSubject: 'searchDialog',
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {
            visibleProducts: visibleProducts,
            visibleTabsCount: visibleTabsCount,
            isRovoCrossProductSearchLinkShown: isRovoCrossProductSearchLinkShown,
            activeProduct: activeProduct,
            bitbucketWorkspacesCount: bitbucketWorkspacesCount,
            selectedBitbucketWorkspace: selectedBitbucketWorkspace
        }
    };
};
const $a652ba3ef37d13f7$export$9e2ba0ae72f48da8 = ({ filterType: filterType })=>{
    return {
        action: 'viewed',
        actionSubject: 'filterField',
        actionSubjectId: 'dropdownMenuFilterField',
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {
            filterType: filterType
        }
    };
};
const $a652ba3ef37d13f7$export$151951fdc112763c = ({ filterId: filterId, filterType: filterType, filterSource: filterSource })=>{
    return {
        action: 'selected',
        actionSubject: 'filter',
        actionSubjectId: 'searchDialogFilter',
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {
            filterId: filterId,
            filterType: filterType,
            filterSource: filterSource
        }
    };
};
const $a652ba3ef37d13f7$export$f448c439d93613dd = ({ filterId: filterId, filterType: filterType, filterSource: filterSource })=>{
    return {
        action: 'unselected',
        actionSubject: 'filter',
        actionSubjectId: 'searchDialogFilter',
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {
            filterId: filterId,
            filterType: filterType,
            filterSource: filterSource
        }
    };
};
const $a652ba3ef37d13f7$export$2e387d28788cf23b = ({ filterType: filterType })=>{
    return {
        action: 'cleared',
        actionSubject: 'filterField',
        actionSubjectId: 'searchDialogFilterField',
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {
            filterType: filterType
        }
    };
};
const $a652ba3ef37d13f7$export$e785b4d14ffa4348 = ()=>{
    return {
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'searchDialogClearFilters',
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {}
    };
};
const $a652ba3ef37d13f7$export$8ba00734f8071933 = (product, duration)=>{
    return {
        action: 'loadComplete',
        actionSubject: 'searchDialogPane',
        actionSubjectId: product,
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'track',
        attributes: {
            durationMs: duration
        }
    };
};
const $a652ba3ef37d13f7$export$d9576525adc921c1 = (abTest, experimentRequestDuration, isMultiProduct)=>{
    return {
        action: 'loaded',
        actionSubject: 'experiment',
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'operational',
        attributes: {
            abTest: abTest,
            experimentRequestDuration: experimentRequestDuration,
            isMultiProduct: isMultiProduct
        }
    };
};
const $a652ba3ef37d13f7$export$1c45c07dd15a8ffa = ()=>{
    return {
        action: 'failed',
        actionSubject: 'experiment',
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'operational',
        attributes: {
            error: 'GetBackendExperimentFailed'
        }
    };
};
const $a652ba3ef37d13f7$export$cb0c8d6d4bf862f8 = ({ tabName: tabName }, additionalContext = {}, nonPrivacySafeAttributes = {
    query: ''
})=>{
    // this event is fired at the same level as the anlytics context hence it needs mandatory additional objects.
    return {
        action: 'clicked',
        actionSubject: 'tab',
        actionSubjectId: 'crossProductSearchTab',
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {
            tabName: tabName,
            ...additionalContext
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    };
};
const $a652ba3ef37d13f7$export$e89c96d52a36944 = (authorised, product)=>{
    return {
        action: 'checked',
        actionSubject: 'thirdPartyAuth',
        actionSubjectId: product,
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'track',
        attributes: {
            authorised: authorised
        }
    };
};
const $a652ba3ef37d13f7$export$a93c057f87e755b3 = (product)=>{
    return {
        action: 'authorised',
        actionSubject: 'thirdPartyProduct',
        actionSubjectId: product,
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'track',
        attributes: {}
    };
};
const $a652ba3ef37d13f7$var$createEvent = (eventType, action, actionSubject, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        attributes: {
            ...attributes
        }
    });
const $a652ba3ef37d13f7$var$position = (options, value)=>{
    return value ? options.findIndex((option)=>option.id === value.data.id) : -1;
};
const $a652ba3ef37d13f7$var$result = (option)=>{
    return option ? $a652ba3ef37d13f7$var$optionData2Analytics(option.data) : null;
};
const $a652ba3ef37d13f7$var$optionData2Analytics = (option)=>{
    const { id: id, type: type } = option;
    return {
        id: id ? id : null,
        type: type || null
    };
};
const $a652ba3ef37d13f7$var$createDefaultPickerAttributes = (fieldId, collabGraphSessionId)=>({
        context: fieldId,
        isCheckbox: true,
        queryLength: 0,
        collabGraphSessionId: collabGraphSessionId
    });
const $a652ba3ef37d13f7$export$48143d759475d90f = (value, options, fieldId, collabGraphSessionId)=>{
    return $a652ba3ef37d13f7$var$createEvent('ui', 'clicked', 'userPicker', {
        ...$a652ba3ef37d13f7$var$createDefaultPickerAttributes(fieldId, collabGraphSessionId),
        position: $a652ba3ef37d13f7$var$position(options, value),
        result: $a652ba3ef37d13f7$var$result(value)
    });
};
const $a652ba3ef37d13f7$export$73da5bde227e14d8 = ()=>{
    return {
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'recentSearch',
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {}
    };
};
const $a652ba3ef37d13f7$export$1338fc4f37de8396 = ()=>{
    return {
        action: 'shown',
        actionSubject: 'aiOnboardingPrompt',
        actionSubjectId: 'prequeryBanner',
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {}
    };
};
const $a652ba3ef37d13f7$export$e7721900a147b5b2 = (promptId)=>{
    return {
        action: 'clicked',
        actionSubject: 'aiOnboardingPrompt',
        actionSubjectId: promptId,
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {}
    };
};
const $a652ba3ef37d13f7$export$889f319cb696bfae = ()=>{
    return {
        action: 'clicked',
        actionSubject: 'aiOnboardingPrompt',
        actionSubjectId: 'dismissButton',
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {}
    };
};
const $a652ba3ef37d13f7$export$e98932ab9e22c265 = ({ reason: reason })=>{
    return {
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        action: 'degradedDependency',
        actionSubject: 'searchPage',
        eventType: 'track',
        attributes: {
            additionalAttributes: {
                degradedDependency: 'search-config',
                reason: reason
            }
        }
    };
};
const $a652ba3ef37d13f7$export$7199f2d13e6ae9f7 = ()=>{
    return {
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        action: 'failedDependency',
        actionSubject: 'searchPage',
        eventType: 'track',
        attributes: {
            additionalAttributes: {
                failedDependency: 'search-config'
            }
        }
    };
};
module.exports["DEFAULT_GAS_CHANNEL"] = $a652ba3ef37d13f7$export$ed78826c06dd24e3;
module.exports["Trigger"] = $a652ba3ef37d13f7$export$41fb9f06171c75f4;
module.exports["AdvancedSearchLinkSubjectId"] = $a652ba3ef37d13f7$export$f7a2a633defbe589;
module.exports["onAdvancedSearchSelected"] = $a652ba3ef37d13f7$export$b544183e0becb531;
module.exports["onXButtonClicked"] = $a652ba3ef37d13f7$export$19360e9b825e4dfb;
module.exports["onNonDebouncedSearchTriggered"] = $a652ba3ef37d13f7$export$72e9f7dfc882e584;
module.exports["onStickySearchCleared"] = $a652ba3ef37d13f7$export$9cb41cdfd7c5452f;
module.exports["onAutocorrectShown"] = $a652ba3ef37d13f7$export$b4f9d93cc4bd7b82;
module.exports["onAutocorrectClicked"] = $a652ba3ef37d13f7$export$33cdbdfa7f154d6c;
module.exports["onHoverPreviewShow"] = $a652ba3ef37d13f7$export$82cfcc46988a9165;
module.exports["onHoverPreviewShown"] = $a652ba3ef37d13f7$export$c666b7de327a3cc2;
module.exports["onHoverPreviewClicked"] = $a652ba3ef37d13f7$export$dfba1b0d5d9e4887;
module.exports["onCardRequestFailed"] = $a652ba3ef37d13f7$export$4b429c3d1a2c2d67;
module.exports["onSearchResultViewAllLinkClicked"] = $a652ba3ef37d13f7$export$b87f0592bfac0edc;
module.exports["onMultiSiteAdvancedSearchSelected"] = $a652ba3ef37d13f7$export$62946e9fdc11ae8d;
module.exports["onMoreFiltersSelected"] = $a652ba3ef37d13f7$export$6c5bd82ba411ffb0;
module.exports["onSearchResultSelected"] = $a652ba3ef37d13f7$export$7816fccc5a0a2fed;
module.exports["onSearchResultHighlighted"] = $a652ba3ef37d13f7$export$95ef6569b5b2de4a;
module.exports["onSearchResultContext"] = $a652ba3ef37d13f7$export$656ab76fbb25e04;
module.exports["ResultsShownActionSubjectId"] = $a652ba3ef37d13f7$export$676101ab18001bd5;
module.exports["onSearchResultsShown"] = $a652ba3ef37d13f7$export$2d1da932f40a427e;
module.exports["onTextEntered"] = $a652ba3ef37d13f7$export$db28d8e16fb16e80;
module.exports["onPreQueryScreenViewed"] = $a652ba3ef37d13f7$export$145f05df248491e5;
module.exports["onRequestMade"] = $a652ba3ef37d13f7$export$93a340bed59d6525;
module.exports["onDismissed"] = $a652ba3ef37d13f7$export$97e12e4b0f216b1d;
module.exports["onShown"] = $a652ba3ef37d13f7$export$e79368bde551c62e;
module.exports["onDropdownMenuFilterView"] = $a652ba3ef37d13f7$export$9e2ba0ae72f48da8;
module.exports["onFilterSelect"] = $a652ba3ef37d13f7$export$151951fdc112763c;
module.exports["onFilterUnselect"] = $a652ba3ef37d13f7$export$f448c439d93613dd;
module.exports["onFilterFieldCleared"] = $a652ba3ef37d13f7$export$2e387d28788cf23b;
module.exports["onPaneLoadComplete"] = $a652ba3ef37d13f7$export$8ba00734f8071933;
module.exports["onGetBackendExperimentFailed"] = $a652ba3ef37d13f7$export$1c45c07dd15a8ffa;
module.exports["onTabSelected"] = $a652ba3ef37d13f7$export$cb0c8d6d4bf862f8;
module.exports["selectEvent"] = $a652ba3ef37d13f7$export$48143d759475d90f;
module.exports["onPrequeryBannerShown"] = $a652ba3ef37d13f7$export$1338fc4f37de8396;
module.exports["onSuggestedPromptClick"] = $a652ba3ef37d13f7$export$e7721900a147b5b2;
module.exports["onPrequeryBannerDismiss"] = $a652ba3ef37d13f7$export$889f319cb696bfae;

});

parcelRegister("fJRVo", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $hL7bb = parcelRequire("hL7bb");


var $gF7Az = parcelRequire("gF7Az");

const $95e6c3d859ed2047$export$36d128238e6b60f5 = [];
const $95e6c3d859ed2047$export$1650419e431d3ba3 = (state, action)=>{
    switch(action.type){
        case 'ADD':
            {
                const { payload: newProduct } = action;
                return $95e6c3d859ed2047$export$7caf006d7b64ee15(state, newProduct);
            }
        case 'UPDATE':
            {
                const { payload: updatePayload } = action;
                return $95e6c3d859ed2047$export$8d590d0c8872145e(state, updatePayload);
            }
        case 'SHOW':
            {
                const productIdToShow = action.payload.id;
                return $95e6c3d859ed2047$export$821c121fea76e4f5(state, productIdToShow);
            }
        case 'REMOVE':
            {
                const productIdToRemove = action.payload.id;
                return $95e6c3d859ed2047$export$86a330d9a979afdd(state, productIdToRemove);
            }
        case 'HIDE_ALL':
            return $95e6c3d859ed2047$export$b6d3947c481ec009(state);
        default:
            return state;
    }
};
function $95e6c3d859ed2047$export$7caf006d7b64ee15(products, addPayload) {
    // Check that new product id does not exist already
    if (products.filter((product)=>product.id === addPayload.id).length) return products;
    // Show error in console when duplicate order is added
    const duplicateOrder = products.find(({ order: order })=>order === addPayload.order);
    if (duplicateOrder) // eslint-disable-next-line no-console
    console.error(`product-search-dialog: Duplicate order of ${addPayload.order} has been set for the products of ${duplicateOrder.id} and ${addPayload.id}`);
    // Add product to state and maintain sorted array using order
    const newProduct = {
        ...addPayload,
        isDisplayed: false
    };
    const unsorted = [
        ...products,
        newProduct
    ];
    const sorted = unsorted.sort((a, b)=>a.order - b.order);
    return sorted;
}
function $95e6c3d859ed2047$export$8d590d0c8872145e(products, updatePayload) {
    const productToUpdate = products.find((p)=>p.id === updatePayload.id);
    if (!productToUpdate) throw new Error(`Cannot update ${updatePayload.id} before being added`);
    const validUpdateKeys = [
        'generateAdvancedSearchUrl',
        'tabRenderer'
    ];
    const validUpdatePayload = Object.fromEntries(Object.entries(updatePayload).filter(([key])=>validUpdateKeys.includes(key)));
    Object.assign(productToUpdate, validUpdatePayload);
    return products;
}
function $95e6c3d859ed2047$export$821c121fea76e4f5(products, productIdToShow) {
    return products.map((product)=>({
            ...product,
            isDisplayed: product.id === productIdToShow
        }));
}
function $95e6c3d859ed2047$export$86a330d9a979afdd(products, productIdToRemove) {
    return products.filter((product)=>product.id !== productIdToRemove);
}
function $95e6c3d859ed2047$export$b6d3947c481ec009(products) {
    return products.map((product)=>({
            ...product,
            isDisplayed: false
        }));
}


const $a5724fee76135767$var$ProductContext = /*#__PURE__*/ (0, $42omo.createContext)({
    getProduct: (id)=>undefined,
    getActiveProduct: ()=>undefined,
    getPrimaryProduct: ()=>undefined,
    addProduct: ()=>undefined,
    updateProduct: ()=>undefined,
    removeProduct: ()=>undefined,
    showProduct: ()=>undefined,
    getDefaultAIConfig: ()=>undefined,
    products: []
});
const $a5724fee76135767$export$36d5c2ec3fe68eef = ({ primaryProduct: primaryProduct, __initialProducts: __initialProducts = (0, $95e6c3d859ed2047$export$36d128238e6b60f5), children: children })=>{
    const [products, dispatch] = (0, $42omo.useReducer)((0, $95e6c3d859ed2047$export$1650419e431d3ba3), __initialProducts);
    const { isExpanded: isExpanded } = (0, $gF7Az.useDialogExpansionContext)();
    (0, $42omo.useEffect)(()=>{
        if (!isExpanded) dispatch({
            type: 'HIDE_ALL'
        });
    }, [
        isExpanded
    ]);
    const addProduct = (0, $42omo.useCallback)((payload)=>{
        return dispatch({
            type: 'ADD',
            payload: payload
        });
    }, [
        dispatch
    ]);
    const updateProduct = (0, $42omo.useCallback)((payload)=>{
        return dispatch({
            type: 'UPDATE',
            payload: payload
        });
    }, [
        dispatch
    ]);
    const removeProduct = (0, $42omo.useCallback)((id)=>{
        return dispatch({
            type: 'REMOVE',
            payload: {
                id: id
            }
        });
    }, [
        dispatch
    ]);
    /**
   * @function showProduct will ensure that only one product is displayed at a time
   * @param {string} id - The product id which has to be made visible.
   */ const showProduct = (0, $42omo.useCallback)((id)=>dispatch({
            type: 'SHOW',
            payload: {
                id: id
            }
        }), [
        dispatch
    ]);
    const getActiveProduct = (0, $42omo.useCallback)(()=>{
        return products.find((product)=>product.isDisplayed);
    }, [
        products
    ]);
    const productsRef = (0, $42omo.useRef)({});
    const getProduct = (0, $42omo.useCallback)((id)=>{
        const product = products.find((product)=>product.id === id);
        const productRef = productsRef.current[id];
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hL7bb)))(product, productRef)) productsRef.current[id] = product;
        return productsRef.current[id];
    }, [
        products
    ]);
    const getPrimaryProduct = (0, $42omo.useCallback)(()=>{
        const nominatedPrimaryProduct = primaryProduct && getProduct(primaryProduct);
        const firstRegisteredProduct = products.length > 0 && products[0];
        return nominatedPrimaryProduct || firstRegisteredProduct || undefined;
    }, [
        getProduct,
        primaryProduct,
        products
    ]);
    const getDefaultAIConfig = (0, $42omo.useCallback)(()=>{
        const primaryProduct = getPrimaryProduct();
        if (primaryProduct?.aiSearchConfig) return primaryProduct.aiSearchConfig;
        else return products.filter((product)=>product.aiSearchConfig)[0]?.aiSearchConfig;
    }, [
        products,
        getPrimaryProduct
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($a5724fee76135767$var$ProductContext.Provider, {
        value: {
            getProduct: getProduct,
            getActiveProduct: getActiveProduct,
            getPrimaryProduct: getPrimaryProduct,
            addProduct: addProduct,
            updateProduct: updateProduct,
            removeProduct: removeProduct,
            showProduct: showProduct,
            products: products,
            getDefaultAIConfig: getDefaultAIConfig
        },
        children: children
    });
};
const $a5724fee76135767$export$b5aab9e12d92574f = ()=>(0, $42omo.useContext)($a5724fee76135767$var$ProductContext);
const $a5724fee76135767$export$a1f708a69696ca95 = (WrappedComponent)=>{
    return (props)=>/*#__PURE__*/ (0, $l998X.jsx)(WrappedComponent, {
            ...props,
            ...$a5724fee76135767$export$b5aab9e12d92574f()
        });
};
module.exports["ProductRouter"] = $a5724fee76135767$export$36d5c2ec3fe68eef;
module.exports["useProductContext"] = $a5724fee76135767$export$b5aab9e12d92574f;
module.exports["withProductContext"] = $a5724fee76135767$export$a1f708a69696ca95;

});

parcelRegister("gF7Az", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $71bd8ea3705f0301$export$5d07de159ce5026c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    isExpanded: false,
    setIsExpanded: (isExpanded)=>{},
    allowChangeExpand: (expand)=>{}
});
const $71bd8ea3705f0301$export$4a9c91610a2bc03 = ({ children: children, isExpanded: isExpanded, setIsExpanded: setIsExpanded })=>{
    const [changeExpand, setChangeExpand] = (0, $42omo.useState)(true);
    return /*#__PURE__*/ (0, $l998X.jsx)($71bd8ea3705f0301$export$5d07de159ce5026c.Provider, {
        value: {
            isExpanded: isExpanded,
            setIsExpanded: changeExpand ? setIsExpanded : ()=>{},
            allowChangeExpand: setChangeExpand
        },
        children: children
    });
};
const $71bd8ea3705f0301$export$124a7aa8f9a7a608 = ()=>{
    return (0, $42omo.useContext)($71bd8ea3705f0301$export$5d07de159ce5026c);
};
const $71bd8ea3705f0301$export$be366799d3426bb9 = (WrappedComponent)=>{
    return (props)=>/*#__PURE__*/ (0, $l998X.jsx)(WrappedComponent, {
            ...props,
            ...$71bd8ea3705f0301$export$124a7aa8f9a7a608()
        });
};
module.exports["DialogExpansionContextProvider"] = $71bd8ea3705f0301$export$4a9c91610a2bc03;
module.exports["useDialogExpansionContext"] = $71bd8ea3705f0301$export$124a7aa8f9a7a608;
module.exports["withDialogExpansionContext"] = $71bd8ea3705f0301$export$be366799d3426bb9;

});

parcelRegister("bF0iL", function(module, exports) {
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $aXWIB = parcelRequire("aXWIB");


const $384d74d764657ed7$export$29c048cc57fefaf8 = (0, $aXWIB.defineMessages)({
    absolute: {
        defaultMessage: "You commented on {date}",
        id: "recentWork.eventTypeMessage.absolute.commented"
    },
    relative: {
        defaultMessage: "You commented {date}",
        id: "recentWork.eventTypeMessage.relative.commented"
    }
});
const $384d74d764657ed7$export$99e7e287b0f1db7 = (0, $aXWIB.defineMessages)({
    absolute: {
        defaultMessage: "You created on {date}",
        id: "recentWork.eventTypeMessage.absolute.created"
    },
    relative: {
        defaultMessage: "You created {date}",
        id: "recentWork.eventTypeMessage.relative.created"
    }
});
const $384d74d764657ed7$export$4d0c20aef6601783 = (0, $aXWIB.defineMessages)({
    absolute: {
        defaultMessage: "You edited on {date}",
        id: "recentWork.eventTypeMessage.absolute.edited"
    },
    relative: {
        defaultMessage: "You edited {date}",
        id: "recentWork.eventTypeMessage.relative.edited"
    }
});
const $384d74d764657ed7$export$2cd1ec4decb563bb = (0, $aXWIB.defineMessages)({
    absolute: {
        defaultMessage: "You published on {date}",
        id: "recentWork.eventTypeMessage.absolute.published"
    },
    relative: {
        defaultMessage: "You published {date}",
        id: "recentWork.eventTypeMessage.relative.published"
    }
});
const $384d74d764657ed7$export$3b389551d0b5bf03 = (0, $aXWIB.defineMessages)({
    absolute: {
        defaultMessage: "You updated on {date}",
        id: "recentWork.eventTypeMessage.absolute.updated"
    },
    relative: {
        defaultMessage: "You updated {date}",
        id: "recentWork.eventTypeMessage.relative.updated"
    }
});
const $384d74d764657ed7$export$2d3fe6e7f84a868e = (0, $aXWIB.defineMessages)({
    absolute: {
        defaultMessage: "You viewed on {date}",
        id: "recentWork.eventTypeMessage.absolute.viewed"
    },
    relative: {
        defaultMessage: "You viewed {date}",
        id: "recentWork.eventTypeMessage.relative.viewed"
    }
});
const $384d74d764657ed7$export$9be55d016b768442 = (0, $aXWIB.defineMessages)({
    absolute: {
        defaultMessage: "You worked on {date}",
        id: "recentWork.eventTypeMessage.absolute.workedOn"
    },
    relative: {
        defaultMessage: "You worked on {date}",
        id: "recentWork.eventTypeMessage.relative.workedOn"
    }
});
const $384d74d764657ed7$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    /**
   * Product-agnostic messages
   */ common_updated_date_formatter: {
        id: "product_search_dialog.updated_date_formatter",
        defaultMessage: "Updated {date}"
    },
    common_recently_viewed_section_heading: {
        id: "product_search_dialog.recently_viewed_section_heading",
        defaultMessage: "Recently viewed"
    },
    common_recently_spaces_section_heading: {
        id: "product_search_dialog.recent_spaces_section_heading",
        defaultMessage: "Recent spaces"
    },
    common_recently_worked_with_section_heading: {
        id: "product_search_dialog.recently_worked_with_section_heading",
        defaultMessage: "Recently worked with"
    },
    common_error_state_failed_search_heading: {
        id: "product_search_dialog.error.failed_loading_search_heading",
        defaultMessage: "We're having trouble loading your recently viewed content."
    },
    common_error_state_failed_search_body: {
        id: "product_search_dialog.error.failed_loading_search_body",
        defaultMessage: "It might just be a hiccup. Please try refreshing the page or <emptyLink>try again.</emptyLink>"
    },
    common_empty_state_heading: {
        id: "product_search_dialog.empty.no_results_heading",
        defaultMessage: "We couldn't find anything matching your search."
    },
    common_empty_state_prequery_heading: {
        id: "product_search_dialog.empty_prequery.no_results_heading",
        defaultMessage: "Search for what you need"
    },
    common_error_state_prequery_heading: {
        id: "product_search_dialog.empty_prequery.error_heading",
        defaultMessage: "Something went wrong with showing initial results"
    },
    common_show_more_results_link: {
        id: "product_search_dialog.show_more_results_link",
        defaultMessage: "Show more"
    },
    common_show_all_results_link: {
        id: "product_search_dialog.show_all_results_link",
        defaultMessage: "View all results"
    },
    common_search_people_link: {
        id: "product_search_dialog.search_people_link",
        defaultMessage: "Search people"
    },
    common_search_input_collapsed_placeholder: {
        id: "product_search_dialog.search_input_collapsed_placeholder",
        defaultMessage: "Search"
    },
    common_search_input_aria_label: {
        id: "product_search_dialog.search_input_aria_label",
        defaultMessage: "Search, press enter to navigate to advanced search with your text query"
    },
    common_search_input_enlarged_aria_label: {
        id: "product_search_dialog.search_input_enlarged_aria_label",
        defaultMessage: "Press enter to navigate to advanced search"
    },
    common_empty_state_body: {
        id: "product_search_dialog.empty.no_results_body",
        defaultMessage: "Try again with a different term, or refine your results with <a>Advanced Search</a>"
    },
    common_empty_state_body_no_advanced_search: {
        id: "product_search_dialog.empty.no_results_body_with_no_advanced_search",
        defaultMessage: "Try again with a different term."
    },
    common_give_feedback: {
        id: "product_search_dialog.give_feedback",
        defaultMessage: "Give feedback"
    },
    common_inline_onboarding_title: {
        id: "product_search_dialog.inline_onboarding_title",
        defaultMessage: "Search across Jira and Confluence"
    },
    common_inline_onboarding_body: {
        id: "product_search_dialog.inline_onboarding_body",
        defaultMessage: "Use the Jira and Confluence tabs to search and see recent items in either location."
    },
    common_inline_onboarding_action: {
        id: "product_search_dialog.inline_onboarding_action",
        defaultMessage: "Ok"
    },
    common_search_input_exit_button_label: {
        id: "search_dialog.search_input_exit_label",
        defaultMessage: "Exit Search"
    },
    common_search_input_clear_button_label: {
        id: "search_dialog.search_input_clear_label",
        defaultMessage: "Clear search session"
    },
    multi_site_advanced_search_label: {
        id: "product_search_dialog.multi_site_advanced_search_label",
        defaultMessage: "Search on:"
    },
    multi_site_advanced_search_more_dropdown: {
        id: "product_search_dialog.multi_site_advanced_search_more_dropdown",
        defaultMessage: "{count} more"
    },
    common_autocorrection_label: {
        id: "product_search_dialog.autocorrection.label",
        defaultMessage: "Did you mean"
    },
    /**
   * Cross product
   */ jira_tab_label: {
        id: "cross_product_search_dialog.jira.tab_label",
        defaultMessage: "Jira"
    },
    confluence_tab_label: {
        id: "cross_product_search_dialog.confluence.tab_label",
        defaultMessage: "Confluence"
    },
    atlas_tab_label: {
        id: "cross_product_search_dialog.atlas.tab_label",
        defaultMessage: "Atlas"
    },
    bitbucket_tab_label: {
        id: "cross_product_search_dialog.bitbucket.tab_label",
        defaultMessage: "Bitbucket"
    },
    opsgenie_tab_label: {
        id: "cross_product_search_dialog.opsgenie.tab_label",
        defaultMessage: "Opsgenie"
    },
    trello_tab_label: {
        id: "cross_product_search_dialog.trello.tab_label",
        defaultMessage: "Trello"
    },
    view_all_results_link: {
        id: "cross_product_search_dialog.view_all_results_link",
        defaultMessage: "View all {sectionTitle}"
    },
    recently_viewed_title: {
        id: "cross_product_search_dialog.recently_viewed_title",
        defaultMessage: "Recently Viewed {sectionTitle}"
    },
    /**
   * Common Confluence Messages
   */ confluence_people_section_heading: {
        id: "product_search_dialog.confluence.people_section_heading",
        defaultMessage: "People"
    },
    confluence_content_section_heading: {
        id: "product_search_dialog.confluence.content_section_heading",
        defaultMessage: "Content"
    },
    confluence_spaces_section_heading: {
        id: "product_search_dialog.confluence.spaces_section_heading",
        defaultMessage: "Spaces"
    },
    confluence_search_input_expanded_placeholder: {
        id: "product_search_dialog.confluence.search_input_expanded_placeholder",
        defaultMessage: "Search Confluence"
    },
    confluence_search_input_expanded_placeholder_ai: {
        id: "product_search_dialog.confluence.search_input_expanded_placeholder_ai",
        defaultMessage: "Search or ask questions within your Confluence"
    },
    confluence_pages_blogs_attachments_section_heading: {
        id: "product_search_dialog.confluence.pages_blogs_attachments_section_heading",
        defaultMessage: "Pages, blogs and attachments"
    },
    /**
   * Common Filtering Messages
   */ filters_applied: {
        id: "product_search_dialog.confluence.filters_applied",
        defaultMessage: "Looks like you have some filters applied"
    },
    clear_filters: {
        id: "product_search_dialog.confluence.clear_filters",
        defaultMessage: "Clear filters"
    },
    show_more_filters: {
        id: "search_dialog.filters.group.show-more",
        defaultMessage: "Show more"
    },
    more_filters: {
        id: "product_search_dialog.more_filters",
        defaultMessage: "View all filters"
    },
    no_options_filters: {
        id: "product_search_dialog.no_options_filters",
        defaultMessage: "No options"
    },
    loading_filters: {
        id: "product_search_dialog.loading_filters",
        defaultMessage: "Loading"
    },
    site_filters_title: {
        id: "product_search_dialog.common.site_filters",
        defaultMessage: "Filter by site"
    },
    space_filters_title: {
        id: "product_search_dialog.confluence.space_filters",
        defaultMessage: "Filter by space"
    },
    contributor_filters_title: {
        id: "product_search_dialog.confluence.contributor_filters",
        defaultMessage: "Filter by contributor"
    },
    contributor_filters_find_more: {
        id: "product_search_dialog.confluence.contributor_filters_find_more",
        defaultMessage: "Find a contributor"
    },
    space_filters_find_more: {
        id: "product_search_dialog.confluence.space_filters_find_more",
        defaultMessage: "Find a space"
    },
    site_filters_find_more: {
        id: "product_search_dialog.jira.site_filters_find_more",
        defaultMessage: "Find a site"
    },
    project_filters_find_more: {
        id: "product_search_dialog.jira.project_filters_find_more",
        defaultMessage: "Find a project"
    },
    project_filters_title: {
        id: "product_search_dialog.jira.project_filters",
        defaultMessage: "Filter by project"
    },
    assignee_filters_find_more: {
        id: "product_s earch_dialog.confluence.assignee_filters_find_more",
        defaultMessage: "Find an assignee"
    },
    assignee_filters_title: {
        id: "product_search_dialog.jira.assignee_filters",
        defaultMessage: "Filter by assignee"
    },
    binary_status_category_filters_title: {
        id: "product_search_dialog.jira.issue_filters",
        defaultMessage: "Filter by status"
    },
    binary_status_category_filter_option_done: {
        id: "product_search_dialog.jira.issue_filter_done",
        defaultMessage: "Done"
    },
    binary_status_category_filter_option_open: {
        id: "product_search_dialog.jira.issue_filter_open",
        defaultMessage: "Open"
    },
    date_filter_any_time_label: {
        id: "product_search_dialog.jira.date_filter_any",
        defaultMessage: "Any time"
    },
    date_filter_filters_title: {
        id: "product_search_dialog.jira.date_filters",
        defaultMessage: "Last updated"
    },
    /**
   * Common Jira Messages
   */ jira_advanced_search_label: {
        id: "global_search.jira.advanced_search_label",
        defaultMessage: "Go to all:"
    },
    jira_advanced_search_issues: {
        id: "global_search.jira.advanced_search_issues",
        defaultMessage: "Issues"
    },
    jira_advanced_search_projects: {
        id: "global_search.jira.advanced_search_projects",
        defaultMessage: "Projects"
    },
    jira_advanced_search_boards: {
        id: "global_search.jira.advanced_search_boards",
        defaultMessage: "Boards"
    },
    jira_advanced_search_filters: {
        id: "global_search.jira.advanced_search_filters",
        defaultMessage: "Filters"
    },
    jira_advanced_search_plans: {
        id: "global_search.jira.advanced_search_plans",
        defaultMessage: "Plans"
    },
    jira_advanced_search_people: {
        id: "global_search.jira.advanced_search_people",
        defaultMessage: "People"
    },
    jira_empty_state_prequery_heading: {
        id: "product_search_dialog.jira.empty_prequery.no_results_heading",
        defaultMessage: "Start searching to find your work"
    },
    jira_issues_section_heading: {
        id: "product_search_dialog.jira.issues_section_heading",
        defaultMessage: "Issues"
    },
    jira_boards_projects_filters_section_heading: {
        id: "product_search_dialog.jira.boards_projects_filters_section_heading",
        defaultMessage: "Boards, Projects and Filters"
    },
    jira_projects_filters_section_heading: {
        id: "product_search_dialog.jira.projects_filters_section_heading",
        defaultMessage: "Projects and Filters"
    },
    jira_boards_projects_filters_plans_section_heading: {
        id: "product_search_dialog.jira.boards_projects_filters_plans_section_heading",
        defaultMessage: "Boards, Projects, Filters and Plans"
    },
    jira_view_all_issues_new: {
        id: "product_search_dialog.jira.jira_view_all_issues_new",
        defaultMessage: "View all issues"
    },
    jira_recent_boards_projects_filters_section_heading: {
        id: "product_search_dialog.jira.recent_boards_projects_filters_section_heading",
        defaultMessage: "Recent Boards, Projects and Filters"
    },
    jira_recent_projects_filters_section_heading: {
        id: "product_search_dialog.jira.recent_projects_filters_section_heading",
        defaultMessage: "Recent Projects and Filters"
    },
    jira_recent_boards_projects_filters_plans_section_heading: {
        id: "product_search_dialog.jira.recent_boards_projects_filters_plans_section_heading",
        defaultMessage: "Recent Boards, Projects, Filters and Plans"
    },
    jira_recently_viewed_issues_section_heading: {
        id: "product_search_dialog.jira.recently_viewed_issues_section_heading",
        defaultMessage: "Recently viewed issues"
    },
    jira_search_placeholder: {
        id: "global_search.jira.search_placeholder",
        defaultMessage: "Search Jira"
    },
    jira_search_placeholder_experiment_jsw_enabled: {
        id: "global_search.jira.search_placeholder_experiment_jsw_enabled",
        defaultMessage: "Search for issues, boards, projects, and filters"
    },
    jira_advanced_search_issuesIssueTermRefresh: {
        id: "global_search.jira.advanced_search_issues-issue-term-refresh",
        defaultMessage: "Work items"
    },
    jira_issues_section_headingIssueTermRefresh: {
        id: "product_search_dialog.jira.issues_section_heading-issue-term-refresh",
        defaultMessage: "Work items"
    },
    jira_view_all_issues_newIssueTermRefresh: {
        id: "product_search_dialog.jira.jira_view_all_issues_new-issue-term-refresh",
        defaultMessage: "View all work items"
    },
    jira_recently_viewed_issues_section_headingIssueTermRefresh: {
        id: "product_search_dialog.jira.recently_viewed_issues_section_heading-issue-term-refresh",
        defaultMessage: "Recently viewed work items"
    },
    jira_search_placeholder_experiment_jsw_enabledIssueTermRefresh: {
        id: "global_search.jira.search_placeholder_experiment_jsw_enabled-issue-term-refresh",
        defaultMessage: "Search for work items, boards, projects, and filters"
    }
});
module.exports["commentedEventTypeMessages"] = $384d74d764657ed7$export$29c048cc57fefaf8;
module.exports["createdEventTypeMessages"] = $384d74d764657ed7$export$99e7e287b0f1db7;
module.exports["editedEventTypeMessages"] = $384d74d764657ed7$export$4d0c20aef6601783;
module.exports["publishedEventTypeMessages"] = $384d74d764657ed7$export$2cd1ec4decb563bb;
module.exports["updatedEventTypeMessages"] = $384d74d764657ed7$export$3b389551d0b5bf03;
module.exports["viewedEventTypeMessages"] = $384d74d764657ed7$export$2d3fe6e7f84a868e;
module.exports["defaultEventTypeMessages"] = $384d74d764657ed7$export$9be55d016b768442;
module.exports["messages"] = $384d74d764657ed7$export$defe85febe8b728c;

});

parcelRegister("3S0fp", function(module, exports) {

var $5dFS9 = parcelRequire("5dFS9");


var $7azCD = parcelRequire("7azCD");

const $17f8c3a758c1402a$export$e9131c78c1110376 = (str)=>(0, $7azCD.sha256)(str);
const $17f8c3a758c1402a$export$670ec347a1a78e34 = (e)=>{
    if (e instanceof KeyboardEvent) return (0, $5dFS9.Trigger).RETURN;
    return e.screenX === 0 ? (0, $5dFS9.Trigger).RETURN : (0, $5dFS9.Trigger).CLICK;
};
const $17f8c3a758c1402a$export$dfd8482ecf3b52d8 = (e)=>{
    return !!(e && (e.metaKey || e.ctrlKey || e.shiftKey));
};
const $17f8c3a758c1402a$export$dba3e2bcdbd49da4 = (str)=>{
    return str.length > 0 ? str.split(/\s+/).length : 0;
};
module.exports["sha256Hash"] = $17f8c3a758c1402a$export$e9131c78c1110376;
module.exports["getTrigger"] = $17f8c3a758c1402a$export$670ec347a1a78e34;
module.exports["isNewTab"] = $17f8c3a758c1402a$export$dfd8482ecf3b52d8;
module.exports["getWordCount"] = $17f8c3a758c1402a$export$dba3e2bcdbd49da4;

});

parcelRegister("6dP89", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $5dFS9 = parcelRequire("5dFS9");

const $e245f4bcfda02d2d$export$e955abb82869dc84 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    return {
        fireAnalyticsEvent: (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((payload)=>createAnalyticsEvent(payload).fire((0, $5dFS9.DEFAULT_GAS_CHANNEL)), [
            createAnalyticsEvent
        ])
    };
};
module.exports["useAnalytics"] = $e245f4bcfda02d2d$export$e955abb82869dc84;

});

parcelRegister("5TmpD", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");


var $igBZP = parcelRequire("igBZP");


var $dwp40 = parcelRequire("dwp40");


var $fJRVo = parcelRequire("fJRVo");

var $56bec3c0e37551ba$var$SUPPORTED_LANGUAGES = /*#__PURE__*/ function(SUPPORTED_LANGUAGES) {
    SUPPORTED_LANGUAGES["English"] = "en";
    return SUPPORTED_LANGUAGES;
}($56bec3c0e37551ba$var$SUPPORTED_LANGUAGES || {});
const $56bec3c0e37551ba$export$9e194549e403d7c0 = 'autocorrect';
const $56bec3c0e37551ba$export$8cc0d0855105f007 = 250;
const $56bec3c0e37551ba$export$47c66070d6d6cd6d = (language)=>{
    return Object.values($56bec3c0e37551ba$var$SUPPORTED_LANGUAGES).includes(language);
};
const $56bec3c0e37551ba$export$2c7172743adddb3f = (locale)=>{
    if (locale.includes('-')) return locale.split('-')[0];
    return locale;
};
const $56bec3c0e37551ba$export$68b44e0f3b4076e = (query)=>{
    return query.length >= 4;
};
const $56bec3c0e37551ba$export$bf742519320d45e9 = ()=>{
    const { locale: locale } = (0, $aXWIB.useIntl)();
    const lang = $56bec3c0e37551ba$export$2c7172743adddb3f(locale);
    const { getActiveProduct: getActiveProduct } = (0, $fJRVo.useProductContext)();
    const product = getActiveProduct();
    return {
        autocorrectionEnabled: !!product?.autocorrectEnabled && $56bec3c0e37551ba$export$47c66070d6d6cd6d(lang),
        productId: product?.id || ''
    };
};
const $56bec3c0e37551ba$export$ac1bfa03f151bc79 = (0, (/*@__PURE__*/$parcel$interopDefault($igBZP)))(({ query: query, aggregatorUrl: aggregatorUrl, lang: lang, cloudId: cloudId })=>{
    return (0, $dwp40.utils).requestService({
        url: aggregatorUrl
    }, {
        path: `${$56bec3c0e37551ba$export$9e194549e403d7c0}`,
        requestInit: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                query: query,
                language: lang,
                cloudId: cloudId
            })
        }
    });
}, $56bec3c0e37551ba$export$8cc0d0855105f007);
module.exports["AUTOCORRECT_API_PATH"] = $56bec3c0e37551ba$export$9e194549e403d7c0;
module.exports["DEFAULT_AUTOCORRECT_DEBOUNCE_TIME_MS"] = $56bec3c0e37551ba$export$8cc0d0855105f007;
module.exports["isSupportedLanguage"] = $56bec3c0e37551ba$export$47c66070d6d6cd6d;
module.exports["sanitizeLanguage"] = $56bec3c0e37551ba$export$2c7172743adddb3f;
module.exports["shouldFetchAutocorrection"] = $56bec3c0e37551ba$export$68b44e0f3b4076e;
module.exports["useAutocorrectionEnabled"] = $56bec3c0e37551ba$export$bf742519320d45e9;
module.exports["fetchAutocorrection"] = $56bec3c0e37551ba$export$ac1bfa03f151bc79;

});

parcelRegister("eEbYb", function(module, exports) {
// eslint-disable @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $cStGJ = parcelRequire("cStGJ");

function $bf8f88eeb93453aa$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $bf8f88eeb93453aa$export$44c18d210d5de37b = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e23w5vh4"
})({
    name: "1938zwf",
    styles: "background-color:var(--ds-surface, #FFFFFF);height:16px;width:128px;border-radius:var(--ds-radius-small, 3px)"
});
const $bf8f88eeb93453aa$export$379a552b6c4d77e1 = /*#__PURE__*/ (0, $cStGJ.default)("span", {
    target: "e23w5vh3"
})({
    name: "9gup9y",
    styles: "color:var(--ds-text-accent-red, #AE2E24);font:var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $bf8f88eeb93453aa$export$98340ed1d0e44a86 = /*#__PURE__*/ (0, $cStGJ.default)("a", {
    target: "e23w5vh2"
})({
    name: "10s0jjn",
    styles: "cursor:pointer;color:var(--ds-text-accent-blue, #1558BC);font:var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $bf8f88eeb93453aa$export$c349a6e4bcccfcee = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e23w5vh1"
})({
    name: "wf8ttk",
    styles: "text-transform:initial;font-weight:initial"
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $bf8f88eeb93453aa$export$4bdce96b0ba50afe = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e23w5vh0"
})({
    name: "1nhn7uu",
    styles: "margin-top:var(--ds-space-100, 8px);font:var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);margin-left:var(--ds-space-200, 16px)"
});
module.exports["LoadingSkeleton"] = $bf8f88eeb93453aa$export$44c18d210d5de37b;
module.exports["TextLabelWrapper"] = $bf8f88eeb93453aa$export$379a552b6c4d77e1;
module.exports["TextCorrectionWrapper"] = $bf8f88eeb93453aa$export$98340ed1d0e44a86;
module.exports["AutocorrectWrapper"] = $bf8f88eeb93453aa$export$c349a6e4bcccfcee;
module.exports["NoResultsAutocorrectWrapper"] = $bf8f88eeb93453aa$export$4bdce96b0ba50afe;

});

parcelRegister("USdFJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dwp40 = parcelRequire("dwp40");

const $900262d035411b0d$var$SITE_ARI_REGEX = new RegExp('ari:cloud:(.+)::site/(.+)');
const $900262d035411b0d$export$8837a793ca98a5b5 = (ari)=>{
    if (!ari) return {
        product: '',
        id: ''
    };
    const [_original, product, id] = Array.from(ari.match($900262d035411b0d$var$SITE_ARI_REGEX) || [
        '',
        '',
        ''
    ]);
    return {
        product: product,
        id: id
    };
};



var $k2JFl = parcelRequire("k2JFl");

var $2b525f3653cbc825$var$ProductsFromARI = /*#__PURE__*/ function(ProductsFromARI) {
    ProductsFromARI["JIRA"] = "jira";
    ProductsFromARI["CONFLUENCE"] = "confluence";
    ProductsFromARI["TOWNSQUARE"] = "townsquare";
    return ProductsFromARI;
}($2b525f3653cbc825$var$ProductsFromARI || {});
const $2b525f3653cbc825$var$CONFIG_API_URL = '/configuration/v1';
const $2b525f3653cbc825$export$55ad0abefe643b5f = '/gateway/api/xpsearch-aggregator';
const $2b525f3653cbc825$var$options = {
    path: $2b525f3653cbc825$var$CONFIG_API_URL,
    requestInit: {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    }
};
const $2b525f3653cbc825$var$noAccessState = {
    jiraSites: [],
    confluenceSites: [],
    atlasWorkspaces: []
};
const $2b525f3653cbc825$var$dedupeEntriesById = (arr)=>{
    return arr.filter((initial, index, currentArray)=>currentArray.findIndex((matched)=>matched.id === initial.id) === index);
};
const $2b525f3653cbc825$var$dedupeEntriesByCloudId = (arr)=>{
    return arr.filter((initial, index, currentArray)=>currentArray.findIndex((matched)=>matched.cloudId === initial.cloudId) === index);
};
const $2b525f3653cbc825$export$ba14d9a5a581e827 = (response)=>{
    const groupedProducts = response.resources.reduce((acc, resource)=>{
        const { baseUrl: baseUrl, id: ari, siteName: siteName } = resource;
        const { id: id, product: product } = (0, $900262d035411b0d$export$8837a793ca98a5b5)(ari);
        if (product.includes("jira")) acc.jiraSites && acc.jiraSites.push({
            product: (0, $k2JFl.Products).jira,
            avatarUrl: '',
            cloudId: id,
            siteUrl: baseUrl,
            siteName: siteName
        });
        if (product === "confluence") acc.confluenceSites && acc.confluenceSites.push({
            product: (0, $k2JFl.Products).confluence,
            avatarUrl: '',
            cloudId: id,
            siteUrl: baseUrl,
            siteName: siteName
        });
        if (product === "townsquare") acc.atlasWorkspaces && acc.atlasWorkspaces.push({
            name: siteName,
            id: id,
            baseUrl: baseUrl
        });
        return acc;
    }, $2b525f3653cbc825$var$noAccessState);
    return {
        jiraSites: $2b525f3653cbc825$var$dedupeEntriesByCloudId(groupedProducts.jiraSites),
        confluenceSites: $2b525f3653cbc825$var$dedupeEntriesByCloudId(groupedProducts.confluenceSites),
        atlasWorkspaces: $2b525f3653cbc825$var$dedupeEntriesById(groupedProducts.atlasWorkspaces)
    };
};
const $2b525f3653cbc825$export$16414e90b8f90666 = (props)=>{
    const { aggregatorUrl: aggregatorUrl = `${$2b525f3653cbc825$export$55ad0abefe643b5f}`, skip: skip = false } = props;
    const [accessibleProducts, setAccessibleProducts] = (0, $42omo.useState)(null);
    (0, $42omo.useEffect)(()=>{
        if (!skip && accessibleProducts === null) (0, $dwp40.utils).requestService({
            url: aggregatorUrl
        }, $2b525f3653cbc825$var$options).then((resp)=>{
            setAccessibleProducts($2b525f3653cbc825$export$ba14d9a5a581e827(resp));
        }).catch((_e)=>{
            setAccessibleProducts($2b525f3653cbc825$var$noAccessState);
        });
    }, [
        accessibleProducts,
        setAccessibleProducts,
        aggregatorUrl,
        skip
    ]);
    return accessibleProducts;
};
module.exports["AGGREGATOR_URL"] = $2b525f3653cbc825$export$55ad0abefe643b5f;
module.exports["useSearchConfigClient"] = $2b525f3653cbc825$export$16414e90b8f90666;

});

parcelRegister("k2JFl", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

var $37ea59e9cc74e158$export$92e44ea1079b9ec6 = /*#__PURE__*/ function(Products) {
    Products["jira"] = "JIRA";
    Products["confluence"] = "CONFLUENCE";
    Products["other"] = "OTHER";
    return Products;
}({});
const $37ea59e9cc74e158$var$primaryProductIndex = 0;
const $37ea59e9cc74e158$var$ProductContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    products: [],
    activeIndex: $37ea59e9cc74e158$var$primaryProductIndex,
    primaryProduct: ''
});
const $37ea59e9cc74e158$export$7d76ff5e8c6ff5f2 = ({ children: children, products: products, activeIndex: activeIndex = 0, primaryProduct: primaryProduct = '' })=>/*#__PURE__*/ (0, $l998X.jsx)($37ea59e9cc74e158$var$ProductContext.Provider, {
        value: {
            products: products,
            activeIndex: Math.min(products.length - 1, Math.max(0, activeIndex)),
            primaryProduct: primaryProduct
        },
        children: children
    });
const $37ea59e9cc74e158$export$964e8498268f0fe3 = ()=>(0, $42omo.useContext)($37ea59e9cc74e158$var$ProductContext).products;
const $37ea59e9cc74e158$export$92c6f3c7c09f3247 = ()=>{
    const { products: products, primaryProduct: primaryProduct } = (0, $42omo.useContext)($37ea59e9cc74e158$var$ProductContext);
    return primaryProduct || products[$37ea59e9cc74e158$var$primaryProductIndex];
};
const $37ea59e9cc74e158$export$1fc003d00f9819a9 = ()=>{
    const context = (0, $42omo.useContext)($37ea59e9cc74e158$var$ProductContext);
    return context.products[context.activeIndex];
};
module.exports["Products"] = $37ea59e9cc74e158$export$92e44ea1079b9ec6;
module.exports["useActiveProduct"] = $37ea59e9cc74e158$export$1fc003d00f9819a9;

});

parcelRegister("7H6GR", function(module, exports) {
const $5ebc4269bdb715fd$export$a707596ddc3340c = '---';
const $5ebc4269bdb715fd$export$5204c4564f8b6d00 = '___';
const $5ebc4269bdb715fd$export$6e18f540c8c76192 = (additionalAnalytics)=>{
    const formattedEvents = {};
    if (typeof additionalAnalytics !== 'string') return formattedEvents;
    const events = additionalAnalytics?.split('____');
    events.forEach((event)=>{
        const formattedEvent = event?.split('---');
        const hasProperlyFormattedEvent = formattedEvent.length === 2;
        if (hasProperlyFormattedEvent) formattedEvents[formattedEvent[0]] = formattedEvent[1];
    });
    return formattedEvents;
};
module.exports["valueSeparator"] = $5ebc4269bdb715fd$export$a707596ddc3340c;
module.exports["attributeSeparator"] = $5ebc4269bdb715fd$export$5204c4564f8b6d00;

});

parcelRegister("8WOej", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dlbUV = parcelRequire("dlbUV");


var $fX9Sa = parcelRequire("fX9Sa");


var $d4cCP = parcelRequire("d4cCP");


var $gguok = parcelRequire("gguok");


var $d8Kpd = parcelRequire("d8Kpd");


var $gH8Rx = parcelRequire("gH8Rx");


var $8DZd1 = parcelRequire("8DZd1");


var $djgQ6 = parcelRequire("djgQ6");


var $d5BUD = parcelRequire("d5BUD");


var $b4DX7 = parcelRequire("b4DX7");


var $41GKb = parcelRequire("41GKb");


var $20uDq = parcelRequire("20uDq");


var $11LZV = parcelRequire("11LZV");


var $lzyQK = parcelRequire("lzyQK");


var $hY1Uy = parcelRequire("hY1Uy");


var $dfQbH = parcelRequire("dfQbH");


var $1iV2p = parcelRequire("1iV2p");


var $7t8Pn = parcelRequire("7t8Pn");


var $ayTrS = parcelRequire("ayTrS");


var $hXc8o = parcelRequire("hXc8o");


var $90Icb = parcelRequire("90Icb");


var $lkBga = parcelRequire("lkBga");

const $403c9cfb5b020557$export$c647cb0ee6e282fe = [
    'small',
    'medium'
];
const $403c9cfb5b020557$var$AttachmentFileExtensionMatchers = [
    {
        regexp: /\.(pdf)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($11LZV))),
            (0, (/*@__PURE__*/$parcel$interopDefault($lzyQK)))
        ]
    },
    {
        regexp: /\.(gif)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($d5BUD))),
            (0, (/*@__PURE__*/$parcel$interopDefault($b4DX7)))
        ]
    },
    {
        regexp: /\.(jpeg|jpg|png)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($41GKb))),
            (0, (/*@__PURE__*/$parcel$interopDefault($20uDq)))
        ]
    },
    {
        regexp: /\.(xml|html|js|css|java|jar|war|ear)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($1iV2p))),
            (0, (/*@__PURE__*/$parcel$interopDefault($7t8Pn)))
        ]
    },
    {
        regexp: /\.(zip|tar|gz|bz2|rar)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($dlbUV))),
            (0, (/*@__PURE__*/$parcel$interopDefault($fX9Sa)))
        ]
    },
    {
        regexp: /\.(xlt|xls|xlsm|xlsx|xlst)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($d8Kpd))),
            (0, (/*@__PURE__*/$parcel$interopDefault($gH8Rx)))
        ]
    },
    {
        regexp: /\.(pptx|ppsx|potx|pot|ppt|pptm)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($hY1Uy))),
            (0, (/*@__PURE__*/$parcel$interopDefault($dfQbH)))
        ]
    },
    {
        regexp: /\.(docx|dotx|doc|dot)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($90Icb))),
            (0, (/*@__PURE__*/$parcel$interopDefault($lkBga)))
        ]
    },
    {
        regexp: /\.(wma|wmv|ram|mp3)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($d4cCP))),
            (0, (/*@__PURE__*/$parcel$interopDefault($gguok)))
        ]
    },
    {
        regexp: /\.(mov|mpeg|mpg|mp4|avi)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($ayTrS))),
            (0, (/*@__PURE__*/$parcel$interopDefault($hXc8o)))
        ]
    }
];
const $403c9cfb5b020557$export$724dbd38c6f8ef0 = {
    'application/pdf': [
        (0, (/*@__PURE__*/$parcel$interopDefault($11LZV))),
        (0, (/*@__PURE__*/$parcel$interopDefault($lzyQK)))
    ],
    'image/gif': [
        (0, (/*@__PURE__*/$parcel$interopDefault($d5BUD))),
        (0, (/*@__PURE__*/$parcel$interopDefault($b4DX7)))
    ],
    'image/jpeg': [
        (0, (/*@__PURE__*/$parcel$interopDefault($41GKb))),
        (0, (/*@__PURE__*/$parcel$interopDefault($20uDq)))
    ],
    'image/png': [
        (0, (/*@__PURE__*/$parcel$interopDefault($41GKb))),
        (0, (/*@__PURE__*/$parcel$interopDefault($20uDq)))
    ],
    'text/xml': [
        (0, (/*@__PURE__*/$parcel$interopDefault($1iV2p))),
        (0, (/*@__PURE__*/$parcel$interopDefault($7t8Pn)))
    ],
    'text/html': [
        (0, (/*@__PURE__*/$parcel$interopDefault($1iV2p))),
        (0, (/*@__PURE__*/$parcel$interopDefault($7t8Pn)))
    ],
    'text/css': [
        (0, (/*@__PURE__*/$parcel$interopDefault($1iV2p))),
        (0, (/*@__PURE__*/$parcel$interopDefault($7t8Pn)))
    ],
    'text/javascript': [
        (0, (/*@__PURE__*/$parcel$interopDefault($1iV2p))),
        (0, (/*@__PURE__*/$parcel$interopDefault($7t8Pn)))
    ],
    'text/plain': [
        (0, (/*@__PURE__*/$parcel$interopDefault($8DZd1))),
        (0, (/*@__PURE__*/$parcel$interopDefault($djgQ6)))
    ],
    //NEED TO GIVE THIS AN ICON,
    'application/zip': [
        (0, (/*@__PURE__*/$parcel$interopDefault($dlbUV))),
        (0, (/*@__PURE__*/$parcel$interopDefault($fX9Sa)))
    ],
    'application/x-zip': [
        (0, (/*@__PURE__*/$parcel$interopDefault($dlbUV))),
        (0, (/*@__PURE__*/$parcel$interopDefault($fX9Sa)))
    ],
    'application/x-zip-compressed': [
        (0, (/*@__PURE__*/$parcel$interopDefault($dlbUV))),
        (0, (/*@__PURE__*/$parcel$interopDefault($fX9Sa)))
    ],
    'application/java-archive': [
        (0, (/*@__PURE__*/$parcel$interopDefault($dlbUV))),
        (0, (/*@__PURE__*/$parcel$interopDefault($fX9Sa)))
    ],
    'application/vnd.ms-excel': [
        (0, (/*@__PURE__*/$parcel$interopDefault($d8Kpd))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gH8Rx)))
    ],
    'application/vnd.ms-powerpoint': [
        (0, (/*@__PURE__*/$parcel$interopDefault($hY1Uy))),
        (0, (/*@__PURE__*/$parcel$interopDefault($dfQbH)))
    ],
    'application/msword': [
        (0, (/*@__PURE__*/$parcel$interopDefault($90Icb))),
        (0, (/*@__PURE__*/$parcel$interopDefault($lkBga)))
    ],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
        (0, (/*@__PURE__*/$parcel$interopDefault($d8Kpd))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gH8Rx)))
    ],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.template': [
        (0, (/*@__PURE__*/$parcel$interopDefault($d8Kpd))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gH8Rx)))
    ],
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': [
        (0, (/*@__PURE__*/$parcel$interopDefault($hY1Uy))),
        (0, (/*@__PURE__*/$parcel$interopDefault($dfQbH)))
    ],
    'application/vnd.openxmlformats-officedocument.presentationml.slideshow': [
        (0, (/*@__PURE__*/$parcel$interopDefault($hY1Uy))),
        (0, (/*@__PURE__*/$parcel$interopDefault($dfQbH)))
    ],
    'application/vnd.openxmlformats-officedocument.presentationml.template': [
        (0, (/*@__PURE__*/$parcel$interopDefault($hY1Uy))),
        (0, (/*@__PURE__*/$parcel$interopDefault($dfQbH)))
    ],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
        (0, (/*@__PURE__*/$parcel$interopDefault($90Icb))),
        (0, (/*@__PURE__*/$parcel$interopDefault($lkBga)))
    ],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.template': [
        (0, (/*@__PURE__*/$parcel$interopDefault($90Icb))),
        (0, (/*@__PURE__*/$parcel$interopDefault($lkBga)))
    ],
    'application/x-shockwave-flash': [
        (0, (/*@__PURE__*/$parcel$interopDefault($8DZd1))),
        (0, (/*@__PURE__*/$parcel$interopDefault($djgQ6)))
    ],
    //NEED TO GIVE THIS AN ICON
    'video/quicktime': [
        (0, (/*@__PURE__*/$parcel$interopDefault($ayTrS))),
        (0, (/*@__PURE__*/$parcel$interopDefault($hXc8o)))
    ],
    'audio/x-ms-wma': [
        (0, (/*@__PURE__*/$parcel$interopDefault($d4cCP))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gguok)))
    ],
    'audio/x-ms-wmv': [
        (0, (/*@__PURE__*/$parcel$interopDefault($d4cCP))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gguok)))
    ],
    'video/mpeg': [
        (0, (/*@__PURE__*/$parcel$interopDefault($ayTrS))),
        (0, (/*@__PURE__*/$parcel$interopDefault($hXc8o)))
    ],
    'audio/x-pn-realaudio': [
        (0, (/*@__PURE__*/$parcel$interopDefault($d4cCP))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gguok)))
    ],
    'application/vnd.rn-realmedia': [
        (0, (/*@__PURE__*/$parcel$interopDefault($8DZd1))),
        (0, (/*@__PURE__*/$parcel$interopDefault($djgQ6)))
    ],
    //NEED TO GIVE THIS AN ICON
    'audio/mpeg': [
        (0, (/*@__PURE__*/$parcel$interopDefault($d4cCP))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gguok)))
    ],
    'video/x-msvideo': [
        (0, (/*@__PURE__*/$parcel$interopDefault($ayTrS))),
        (0, (/*@__PURE__*/$parcel$interopDefault($hXc8o)))
    ],
    'video/mp4': [
        (0, (/*@__PURE__*/$parcel$interopDefault($ayTrS))),
        (0, (/*@__PURE__*/$parcel$interopDefault($hXc8o)))
    ],
    'audio/mp4': [
        (0, (/*@__PURE__*/$parcel$interopDefault($d4cCP))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gguok)))
    ],
    'audio/mp3': [
        (0, (/*@__PURE__*/$parcel$interopDefault($d4cCP))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gguok)))
    ],
    default: [
        (0, (/*@__PURE__*/$parcel$interopDefault($8DZd1))),
        (0, (/*@__PURE__*/$parcel$interopDefault($djgQ6)))
    ]
};
const $403c9cfb5b020557$export$2063a590c0694ba8 = (extensions)=>{
    if (!extensions || !Array.isArray(extensions)) return null;
    const mediaType = extensions.find(({ key: key })=>key === 'mediaType');
    return mediaType ? mediaType.value : null;
};
class $403c9cfb5b020557$export$edc04f92718bbea4 extends (0, $42omo.PureComponent) {
    render() {
        const { mediaType: mediaType, label: label, size: size } = this.props;
        const iconArray = this.getIconArray();
        const sizeIndex = $403c9cfb5b020557$export$c647cb0ee6e282fe.indexOf(size ?? 'medium') || 0;
        const icon = iconArray[sizeIndex];
        const testId = `attachment-icon-${mediaType?.replace('/', '-') ?? 'unknown'}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(icon, {
            size: // @ts-expect-error FIXME: `size` is not an acceptable prop here
            size,
            label: label,
            testId: testId
        });
    }
    constructor(...args){
        super(...args);
        this.getIconArray = ()=>{
            const { mediaType: mediaType, title: title } = this.props;
            if (mediaType && $403c9cfb5b020557$export$724dbd38c6f8ef0[mediaType]) return $403c9cfb5b020557$export$724dbd38c6f8ef0[mediaType];
            if (title) {
                const extension = $403c9cfb5b020557$var$AttachmentFileExtensionMatchers.find((extensionMatcher)=>{
                    const matches = extensionMatcher.regexp.exec(title);
                    return !!matches && matches.length > 0;
                });
                if (extension) return extension.icon;
            }
            return $403c9cfb5b020557$export$724dbd38c6f8ef0['default'];
        };
    }
}
module.exports["AttachmentIcon"] = $403c9cfb5b020557$export$edc04f92718bbea4;

});

parcelRegister("1mK5P", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kYvrE = parcelRequire("kYvrE");


var $7Zbm6 = parcelRequire("7Zbm6");


var $5Ymlp = parcelRequire("5Ymlp");


var $bQm3c = parcelRequire("bQm3c");

const $db4dd28f79880540$export$39f60520d0d25b0e = ({ prequeryBannerEnabled: prequeryBannerEnabled, dismissPrequeryBanner: dismissPrequeryBanner })=>{
    const { cloudId: cloudId, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const cloudIdARI = (0, $kYvrE.ConfluenceSiteAri).create({
        siteId: cloudId
    }).toString();
    const aiSearchStreamingFunction = (0, $42omo.useCallback)(({ variables: variables })=>({
            type: (0, $7Zbm6.AIAnswerAPIType).STREAM,
            stream: (0, $5Ymlp.sainStreamFetchConvoAIService)({
                variables: {
                    ...variables,
                    cloudIdARI: cloudIdARI
                },
                isReadingAids: false
            })
        }), [
        cloudIdARI
    ]);
    return {
        aiSearchConfig: isAdminHubAIEnabled ? {
            aiSearchQueryFunction: aiSearchStreamingFunction,
            prequeryBannerEnabled: prequeryBannerEnabled,
            dismissPrequeryBanner: dismissPrequeryBanner,
            followUpsEnabled: true
        } : undefined
    };
};
module.exports["useAISearchSupplier"] = $db4dd28f79880540$export$39f60520d0d25b0e;

});

parcelRegister("1HFOS", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kNUwp = parcelRequire("kNUwp");


var $dbl1i = parcelRequire("dbl1i");


var $2hfy2 = parcelRequire("2hfy2");


var $6yCpa = parcelRequire("6yCpa");


var $1xpoY = parcelRequire("1xpoY");

const $35ce488ded4e8412$var$HELLO_CLOUD_ID = 'a436116f-02ce-4520-8fbb-7301462a1674';
const $35ce488ded4e8412$var$EXPIRATION_TIME = 86400000;
const $35ce488ded4e8412$export$796c8e9967745d9a = ({ cloudId: cloudId, entities: entities, userId: userId, experience: experience })=>{
    const [searchConfig, setSearchConfig] = (0, $42omo.useState)();
    (0, $42omo.useEffect)(()=>{
        if (!cloudId) return;
        (0, $kNUwp.getSearchConfigV2)({
            cloudId: cloudId,
            userId: userId,
            onlyRefreshIfExpired: true,
            expiration: $35ce488ded4e8412$var$EXPIRATION_TIME
        }).then((result)=>{
            setSearchConfig(result);
        }).catch(()=>{
            // TODO: Error handling with Confluence's sentry client
            setSearchConfig({
                siteMetadata: [],
                resources: [],
                intercomHmac: ''
            });
        });
    }, [
        cloudId,
        userId
    ]);
    return (0, $42omo.useMemo)(()=>{
        // Do not return dynamic experiments if search config is not loaded
        if (!searchConfig) return {
            backendExperiment: undefined,
            loading: true
        };
        const dynamicExperiments = (0, $dbl1i.dynamicExperimentsSchema).safeParse((0, $1xpoY.default).getStringList('search_platform_layer_functions', [])).data;
        if (!dynamicExperiments) return {
            backendExperiment: undefined,
            loading: false
        };
        const siteMetadata = searchConfig?.siteMetadata.find((metadata)=>metadata.siteId === cloudId);
        const isHello = siteMetadata?.siteId === $35ce488ded4e8412$var$HELLO_CLOUD_ID;
        const productEdition = siteMetadata?.productEdition;
        const productDataRegions = siteMetadata?.productDataRegions;
        const isJiraIssueIndexed = siteMetadata?.isJiraIssueIndexed;
        const requestedEntities = entities.flatMap((entity)=>{
            try {
                const { resourceOwner: resourceOwner, resourceType: resourceType } = (0, $6yCpa.Ati).parse(entity);
                return [
                    {
                        entity: resourceOwner,
                        subEntity: resourceType.toUpperCase()
                    }
                ];
            } catch  {
                // TODO: Error handling with Confluence's sentry client
                return [];
            }
        });
        const backendExperiment = (0, $2hfy2.mapDynamicExperiments)({
            dynamicExperiments: dynamicExperiments,
            requestedEntities: requestedEntities,
            productEdition: productEdition,
            isHello: isHello,
            productDataRegions: productDataRegions,
            experience: experience,
            tenantId: cloudId,
            isJiraIssueIndexed: isJiraIssueIndexed
        });
        return {
            backendExperiment: backendExperiment,
            productEdition: productEdition,
            loading: false
        };
    }, [
        cloudId,
        entities,
        experience,
        searchConfig
    ]);
};
module.exports["useDynamicBackendExperiment"] = $35ce488ded4e8412$export$796c8e9967745d9a;

});


//# sourceMappingURL=NavigationSearchDialog.a189900b.js.map
